<h3 class="text-lg font-semibold text-gray-800 mb-4 dialog-header">
  <i class="fa-solid fa-triangle-exclamation"></i>
  {{ 'export-creation.form.selectStations.warningDialog.title' | translate }}
</h3>

<div class="space-y-3 text-gray-700 dialog-content">

  <span class="block text-base font-medium">
    <b>{{ `export-creation.form.selectStations.warningDialog.${excludeOrInclude}.title` | translate }}</b>
  </span>

  <ul class="list-disc list-inside space-y-2 pl-1">
    <li class="leading-5">
      {{ `export-creation.form.selectStations.warningDialog.${excludeOrInclude}.subItemOne` | translate }}
    </li>

    <li class="leading-5">
      <b>{{ `export-creation.form.selectStations.warningDialog.${excludeOrInclude}.subItemTow` | translate }}</b>
    </li>
  </ul>
</div>

<div class="commands-container">
  <lib-button
    [label]="`export-creation.form.selectStations.warningDialog.${excludeOrInclude}.accept`| translate"
    (gnvOnClick)="closeMe(true)"
  ></lib-button>

  <lib-button
    [label]="'action.cancel' | translate"
    [severity]="'secondary'"
    (gnvOnClick)="closeMe()"
  ></lib-button>
</div>
